import React, { useState } from "react";
import { message } from "antd";
import firebase from "firebase/app";
import "firebase/auth";

import { CardElement, injectStripe } from "react-stripe-elements";

const createOptions = (fontSize, padding) => {
  return {
    style: {
      base: {
        fontSize,
        color: "#424770",
        letterSpacing: "0.025em",
        "::placeholder": {
          color: "#aab7c4"
        },
        padding
      },
      invalid: {
        color: "#9e2146"
      }
    }
  };
};

const _SplitForm = (props) => {
  const [name, setName] = useState("");

  const handleChange = event => {
    setName(event.target.value);
  };

  const handleSubmit = async ev => {
    ev.preventDefault();
    const userId = firebase.auth().currentUser.uid;

    if (props.state.stripePlan) {
      const db = firebase.firestore();

      const token = await props.stripe.createToken({
        name
      });

      await db
        .collection("stripe_customers")
        .doc(userId)
        .update({
          token: token.token.id,
          plan: props.state.stripePlan,
          account_name: name,
          card_id: token.token.card.id,
          last4: token.token.card.last4,
          brand: token.token.card.brand,
          subscribed: true
        });

      props.stripe._element.clear();
      setName("");
      message.success("Subscription was submitted", 10);
    } else {
      message.error("Please select a plan", 10);
    }
  };

  const handleCardUpdate = async ev => {
    ev.preventDefault();
    console.log("Updating Card");
  };
  
  return (
    <form
      onSubmit={
        props.subscription.length && props.subscription[0].token
          ? handleCardUpdate
          : handleSubmit
      }
    >
      <label style={{ marginBottom: 10 }}>
        Name
        <input
          className="name-input"
          type="text"
          name="name"
          value={name}
          onChange={handleChange}
          {...createOptions(props.fontSize)}
          placeholder="Name on card"
        />
      </label>
      <label>
        Card Details
        <CardElement
          onReady={c => (props.stripe._element = c)}
          {...createOptions(props.fontSize)}
        />
      </label>
      {props.subscription.length && props.subscription[0].token ? (
        <button className="stripe-button">Update Card</button>
      ) : (
        <button className="stripe-button">Subscribe</button>
      )}
    </form>
  );
};
const CardForm = injectStripe(_SplitForm);

export default CardForm;
